import { SourceProps } from 'gatsby-plugin-image/dist/src/components/picture'

export const getImageSources = (imageProps: GatsbyImageStoryblokProps) => {
  const sources: SourceProps[] = []

  if (imageProps.srcSetWebp) {
    sources.push({
      srcSet: imageProps.srcSetWebp,
      type: 'image/webp'
    })
  }

  if (!imageProps.srcSetWebp && imageProps.srcSet) {
    sources.push({
      media: '',
      srcSet: imageProps.srcSet
    })
  }

  return sources
}
